import { render, staticRenderFns } from "./modal-tna-mitra-detail.vue?vue&type=template&id=4a1e8fc8&scoped=true"
import script from "./modal-tna-mitra-detail.vue?vue&type=script&lang=js"
export * from "./modal-tna-mitra-detail.vue?vue&type=script&lang=js"
import style0 from "./modal-tna-mitra-detail.vue?vue&type=style&index=0&id=4a1e8fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1e8fc8",
  null
  
)

export default component.exports